<template>
    <el-card shadow="never">
        <template #header>
          <div class="header">
            <el-breadcrumb class="breadcrumb" separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
              <el-breadcrumb-item>产品列表</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="primary" class="editbtn" @click="add">创建产品</el-button>
          </div>
        </template>
        <el-form :model="searchForm" inline label-width="120px">
          <el-form-item label="产品品类">
            <el-cascader
              v-model="searchForm.cates"
              :options="baseData.cateslist"
              :props="propss"
              clearable
              @change="handleChange"
            />
          </el-form-item>
          <el-form-item label="关键词">
            <el-input v-model="searchForm.words" placeholder="产品名称"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
        <el-table row-key="id" v-loading="baseData.loading" border :data="tableData.data" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="id" label="id" width="60"/>
          <el-table-column prop="img" label="封面图" width="140">
            <template #default="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.img"
                fit="cover"
              />
            </template>
          </el-table-column>
          <el-table-column prop="title" label="产品名称"/>
          <el-table-column prop="catagory" label="分类名称" width="140"/>
          <el-table-column prop="introduction" label="简介"/>
          <el-table-column prop="click" label="游览量" width="100" />
          <el-table-column prop="remark" label="备注">
            <template #default="scope">
              <p v-if="scope.row.remark">{{scope.row.remark}}</p>
              <el-tag v-if="scope.row.remark" type="success" @click="showRemark(scope.row)">查看记录 > </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" width="160"/>
          <el-table-column prop="status" label="状态" width="100" >
            <template #default="scope">
              <el-text v-if="scope.row.status==0" type="danger">冻结</el-text>
              <el-text v-if="scope.row.status==1" type="warning">待审核</el-text>
              <el-text v-if="scope.row.status==2" type="success">正常</el-text>
              <el-text v-if="scope.row.status==3" type="danger">审核不通过</el-text>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="200" >
            <template #default="scope">
              <el-button size="small" @click="showtan(scope.row)" type="warning">审核</el-button>
              <el-button size="small" @click="edit(scope.row.id)" type="primary">编辑</el-button>
              <el-popconfirm
                confirm-button-text="是"
                cancel-button-text="否"
                title="确定删除吗?"
                @confirm="del(scope.row.id)"
              >
                <template #reference>
                  <el-button size="small" type="danger">删除</el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagestyle">
          <el-pagination
            v-model:current-page="searchForm.page"
            v-model:page-size="searchForm.limit"
            layout="sizes, prev, pager, next"
            :total="tableData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-card>
      <el-dialog v-model="baseData.examinebox" title="审核" width="80%">
        <el-descriptions title="商品信息" :column="3" border>
          <el-descriptions-item label="名称">{{baseData.goods.title}}</el-descriptions-item>
          <el-descriptions-item label="所属公司">{{baseData.goods.title}}</el-descriptions-item>
          <el-descriptions-item label="分类名称">{{baseData.goods.catagory}}</el-descriptions-item>
          <el-descriptions-item label="推荐">{{baseData.goods.recommend ? "是" : "否"}}</el-descriptions-item>
          <el-descriptions-item label="简介">{{baseData.goods.introduction}}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-text v-if="baseData.goods.status==0" type="danger">冻结</el-text>
            <el-text v-if="baseData.goods.status==1" type="warning">待审核</el-text>
            <el-text v-if="baseData.goods.status==2" type="success">正常</el-text>
          </el-descriptions-item>
          <el-descriptions-item label="公司轮播图">
            <img v-for="item in baseData.goods.imglist" v-bind:key="item.url" :src="item.url" style="width:100px;height:100px;margin-left:10px" />
          </el-descriptions-item>
          <el-descriptions-item label="公司详情图">
            <img v-for="item in baseData.goods.detailimglist" v-bind:key="item.url" :src="item.url" style="width:100px;height:100px;margin-left:10px" />
          </el-descriptions-item>
        </el-descriptions>
        <el-form :model="baseData" style="margin-top: 20px;">
          <el-form-item label="备注" label-width="60">
            <el-input v-model="baseData.examineRemark" autocomplete="off" :rows="2" type="textarea"/>
          </el-form-item>
        </el-form>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="baseData.examinebox = false">取消</el-button>
            <el-button type="danger" @click="examine(3)">审核不成功</el-button>
            <el-button type="success" @click="examine(2)">审核成功</el-button>
          </div>
        </template>
      </el-dialog>
      <el-drawer v-model="baseData.goodsdrawer">
        <template #header>
          <h4>{{baseData.goods.title}}</h4>
        </template>
        <template #default>
          <div>
            <el-timeline style="max-width: 600px">
              <el-timeline-item
                v-for="(item, index) in baseData.remarklog"
                :key="index"
                :timestamp="item.created_at"
              >
                <p>{{ item.remark }}</p>
                <p>操作人：{{ item.Username }}</p>
              </el-timeline-item>
            </el-timeline>
          </div>
        </template>
        <template #footer>
          <div style="flex: auto">
            <el-button @click="baseData.goodsdrawer = false">关闭</el-button>
          </div>
        </template>
      </el-drawer>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'

  const router = useRouter()
  const searchForm:any = reactive({
    cates:[],
    cate:"",
    words:"",
    limit:10,
    page:1,
  })
  const propss = {
    expandTrigger: 'hover' as const,
    value:'id',
    label:'title',
    children:'Children',
  }
  const baseData:any = reactive({
    loading:false,
    title:'',
    examinebox:false,
    goodsdrawer:false,
    cateslist:[],
    remarklog:[],
    goods:{},
    examineRemark:""
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const handleChange = (value:any) => {
    searchForm.cate = value[value.length - 1]
  }
  const showRemark = (data:any) => {
    api.goodsApi.get_remark_log({id:data.id}).then((res:any)=>{
      if(res.code==200){
        baseData.goodsdrawer = true
        baseData.goods = data
        baseData.remarklog = res.data
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const showtan = (data:any) => {
    baseData.examinebox = true
    baseData.goods = data
  }
  const search = () => {
    searchForm.page = 1
    getList()
  }
  const reset = () => {
    searchForm.page = 1
    searchForm.limit = 10
    searchForm.words = ""
    searchForm.cate = ""
    searchForm.cates = []
    getList()
  }

  const examine = (status:number) => {
    let data = {
      id:baseData.goods.id,
      status:status,
      remark:baseData.examineRemark
    }
    
    api.goodsApi.examine(data).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        baseData.examinebox = false
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const changeGoodStatus = (id:string) =>{
    api.goodsApi.changeGoodStatus({id:id}).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
      }else{
        ElMessage.error(res.message)
      }
      getList()
    })
  }
  const getList = () => {
    localStorage.setItem('goodspage',searchForm.page);
    localStorage.setItem('goodscate',searchForm.cate);
    localStorage.setItem('goodswords',searchForm.words);
    localStorage.setItem('goodslimit',searchForm.limit);
    baseData.loading = true
    api.goodsApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        let list = res.data.list
        for(let i in list){
          list[i].Status = list[i].Status==1?true:false
        }
        tableData.data = list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = (id:any) => {
    router.push("/goods/add");
  }
  const edit = (id:any) => {
    router.push("/goods/edit/"+id);
  }
  const del = (id:number) => {
    baseData.loading = true
    api.goodsApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getCatesList = () => {
    baseData.loading = true
    api.goodsApi.get_cates_list({limit:1000,page:1}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        baseData.cateslist = res.data.list
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    searchForm.page = localStorage.getItem('goodspage') ? parseInt(localStorage.getItem('goodspage')) : 1;
    searchForm.cate = localStorage.getItem('goodscate') ? localStorage.getItem('goodscate') : '';
    searchForm.words = localStorage.getItem('goodswords') ? localStorage.getItem('goodswords') : '';
    searchForm.limit = localStorage.getItem('goodslimit') ? parseInt(localStorage.getItem('goodslimit')) : 10;
    getList()
    getCatesList()
  })
  </script>

  <style scoped>
  .el-descriptions {
    margin-top: 20px;
  }
  .cell-item {
    display: flex;
    align-items: center;
  }
  .margin-top {
    margin-top: 20px;
  }
  </style>